module.exports = __webpack_public_path__ + "static/media/company-logo-8.9d405951.png";